import {
  IFlowDestinationListItem,
  IFlowDestinationsPageItem,
  ISegmentDestinationsItem,
} from '_/features/flowDestinations/flowDestinations.types';
import { IFlowDestination } from '_/features/flows/common/types/flowSegments.types';

import { IFlowDestinationsPageDataAdapterParams, IFlowSegmentDestinationsAdapterParams } from './flowDestinations.adapter.types';

export const segmentDestinationsAdapter = (segmentDestinations: IFlowDestinationListItem[]): Record<string, IFlowDestination[]> =>
  segmentDestinations.reduce(
    (acc, { id, destinations }) => ({
      ...acc,
      [id]: destinations,
    }),
    {},
  );

export const flowSegmentDestinationsAdapter = ({
  flowSegmentId,
  orgDestinations,
  segmentsDestinationsMap,
  overrideDestinations = true,
}: IFlowSegmentDestinationsAdapterParams): ISegmentDestinationsItem[] =>
  orgDestinations.map((destination) => {
    const linked = segmentsDestinationsMap[flowSegmentId]?.find(({ id }) => id === destination.id);
    return {
      ...destination,
      flowSegmentId: flowSegmentId,
      flowDestinationId: linked?.id,
      overrideDestinations: overrideDestinations,
    };
  });

export const flowDestinationsPageDataAdapter = ({
  collectionsDestinationsMap,
  orgDestinations,
  flow,
  orgSlug,
  projectSlug,
  segmentsDestinationsMap,
  segments,
}: IFlowDestinationsPageDataAdapterParams): IFlowDestinationsPageItem[] => {
  const isChainedFlow = !!flow?.definition?.chains;

  return segments.map(({ id: flowSegmentId, collectionId, collection, overrideDestinations }, index) => {
    const { name = '', slug = '' } = collection || {};
    const segmentKey = index + 1;
    const header = isChainedFlow ? `Segment ${segmentKey}: ${name}` : name;
    const href = `/orgs/${orgSlug}/projects/${projectSlug}/collections/${slug}/destinations`;

    const destinations = overrideDestinations
      ? flowSegmentDestinationsAdapter({
          flowSegmentId: flowSegmentId,
          orgDestinations: orgDestinations,
          segmentsDestinationsMap: segmentsDestinationsMap,
          overrideDestinations: overrideDestinations,
        })
      : collectionsDestinationsMap[collectionId] ||
        orgDestinations.map((destination) => ({
          ...destination,
          flowSegmentId: flowSegmentId,
          flowDestinationId: undefined,
          overrideDestinations: false,
        }));

    return {
      collectionId: collectionId,
      destinations: destinations,
      flowSegmentId: flowSegmentId,
      header: header,
      href: href,
      overrideDestinations: overrideDestinations,
      segmentKey: segmentKey,
    };
  });
};
